import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthModalWidget from '../components/AuthModalWidget';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // If user is already authenticated, redirect to home
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    // Open the modal automatically when the page loads with a small delay
    // to ensure the page is fully rendered
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate]);

  const handleClose = () => {
    setIsModalOpen(false);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <AuthModalWidget
        isOpen={isModalOpen}
        onClose={handleClose}
        onHideForWalletConnect={() => setIsModalOpen(false)}
        initialMode="login"
      />
    </div>
  );
};

export default LoginPage;
